import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import classes from './override.module.scss';

type Props = {};

export const WithdrawContactFormTemplate = memo((_props: Props) => {
	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenID 退会';
	}, []);

	return (
		<>
			<section className="section mypage">
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>{`GakkenIDを退会する`}</li>
					</ul>
				</div>
				<h1 className="page-head" ref={scrollRef}>{`GakkenIDを退会する`}</h1>
				<div className="section-in">
					<div className={`section-head`}>
						<span>注意事項をご確認ください</span>
					</div>
					<div className="section-txt-box">
						<p>
							お客様のGakkenIDは、この手続きにて退会することができません。GakkenIDの退会をご希望の場合、GakkenIDお問い合わせフォームよりご連絡ください。
						</p>
						<div>
							※GakkenIDを退会すると、GakkenIDを使用するサービスが利用できなくなります。また、GakkenIDに登録されているすべてのデータの参照もできなくなります。
							<br />
							※退会手続き後は、マイページのご利用ができなくなり、退会したGakkenIDについては再開することはできません。
						</div>
						<div className="btn-box">
							<div className="btn wh">
								<a
									href="https://contact.gakken.jp/user/op_enquete.gsp?sid=1035&mid=000111yf&hid=i0D6Wk2R4_0"
									target="_blank"
								>
									お問い合わせフォームへ
								</a>
							</div>
							<div className="btn gr">
								<Link to={RoutePath.MY_PAGE}>戻る</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
});
